import { DatePipe } from "@angular/common";
import { Zone } from "./zone";
import { formatDate } from '@angular/common';


type ActionLogCategory = 'rules' | 'action' | 'security' | 'settings' |  'report';

export class ActionLog {
    category: ActionLogCategory;
    meta: any;
    zone: Zone;
    isError: boolean;
    user: any;
    createdAt: Date;
    subject: any;
    subjectType: string;
    eventType: string;
    company: any;
    text: string;

    constructor(data: any) {
        this.zone = data.zone;
        this.user = data.user;
        this.createdAt = data.createdAt;
        this.isError = data.isError;
        this.meta = data.meta;
        this.category = data.category;
        this.subject = data.subject;
        this.subjectType = data.subjectType;
        this.eventType = data.eventType;
        this.company = data.company;
        this.text = data?.text;
    }
    get message(): string {
        
        try {

            if (this.text){
                return `
                    ${this.text}
                `;
            }
            else{
                return 'unknown';
            }

        } catch (error) {
            return 'unknown'
        }    
    }
}